/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyTeamsIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-teams" */ './utils').then((m) => m.TeamsIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/teams/icon' },
);

const LazyTeamsSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-teams-search-result" */ './utils').then(
			(m) => m.TeamsSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/teams/search-result-icon' },
);

const LazyTeamsIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-teams-borderless" */ './utils').then(
			(m) => m.TeamsIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/teams/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const TeamsIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyTeamsIconComponent />
	</Suspense>
);

export const TeamsSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyTeamsSearchResultIconComponent />
	</Suspense>
);

export const TeamsIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyTeamsIconBorderlessComponent />
	</Suspense>
);
